import axios from "axios";

const API_BASE =
  process.env.REACT_APP_API_URL || "http://localhost:5000/reactApi/api";

export const getComplaintList = (params) => {
  return axios.get(`${API_BASE}/complaint/list`, { params });
};

export const getComplaintTypes = (complaintAgainst) => {
  return axios.get(`${API_BASE}/complaint/types/${complaintAgainst}`);
};

export const registerComplaint = (complaintData) => {
  return axios.post(`${API_BASE}/complaint/register`, complaintData);
};

export const saveComplaintFiles = (fileData) => {
  return axios.post(`${API_BASE}/complaint/save-files`, fileData);
};

export const getComplaintDetails = async ({ id }) => {
  const response = await axios.get(`${API_BASE}/complaint/complaint-data/${id}`);
  return response.data;
};
// Get lab info by CAB ID
export const getLabInfo = async ({ cabId }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/labinfo`, { cabId });
  return response.data;
};

// Save mark (Valid/Invalid)
export const saveComplaintMark = async (payload) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/saveMark`, payload);
  return response.data;
};

// Final submit after marking
export const finalSubmit = async ({ id, isMark }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/finalSubmit`, {
    id,
    isMark,
  });
  return response.data;
};

// Upload investigation document (only metadata)
export const uploadDocument = async (data) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/uploadDoc`, data);
  return response.data;
};

// Final submit for investigation documents
export const documentFinalSubmit = async ({ id }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/docFinal`, { id });
  return response.data;
};

// Close complaint
export const closeComplaint = async (data) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/close`, data);
  return response.data;
};

// Save clarification draft
export const saveClarification = async (data) => {
  const response = await axios.post(
    `${API_BASE}/complaint/complaint-data/clarification`,
    data,
  );
  return response.data;
};

// Submit clarification final
export const submitClarification = async ({ id, complaintId }) => {
  const response = await axios.post(
    `${API_BASE}/complaint/complaint-data/clarification/submit`,
    { id, complaintId },
  );
  return response.data;
};

// Show Cause – add point
export const addShowCausePoint = async ({ complaintId, description, type }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/showcause/point`, {
    complaintId,
    description,
    type,
  });
  return response.data;
};

// Update show cause point
export const updateShowCausePoint = async ({ id, description }) => {
  const response = await axios.post(
    `${API_BASE}/complaint/complaint-data/showcause/point/update`,
    { id, description },
  );
  return response.data;
};

// Delete show cause point
export const deleteShowCausePoint = async ({ id }) => {
  const response = await axios.post(
    `${API_BASE}/complaint/complaint-data/showcause/point/delete`,
    { id },
  );
  return response.data;
};

// Save show cause letter
export const saveShowCauseLetter = async ({ complaintId, subject, body }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/showcause/letter`, {
    complaintId,
    subject,
    body,
  });
  return response.data;
};

// Get joint directors list
export const getJointDirectors = async ({ complaintId }) => {
  const response = await axios.post(`${API_BASE}/complaint/complaint-data/jointDirectors`, {
    complaintId,
  });
  return response.data;
};

// Forward show cause to lab
export const forwardShowCause = async (data) => {
  const response = await axios.post(
    `${API_BASE}/complaint/complaint-data/forwardShowCause`,
    data,
  );
  return response.data;
};

  export const getApplications = async ({ orgId }) => {
    const response = await axios.post(`${API_BASE}/complaint/permissions`, { orgId });
    return response.data;
  };

  // Get disciplines (LabApplications_Acts mode 68)
  export const getDisciplines = async ({ appId, labTypeId }) => {
    const response = await axios.post(`${API_BASE}/complaint/disciplines`, { appId, labTypeId });
    return response.data;
  };

  // Get groups (LabApplications_Acts mode 69)
  export const getGroups = async ({ appId, labTypeId }) => {
    const response = await axios.post(`${API_BASE}/complaint/groups`, { appId, labTypeId });
    return response.data;
  };

  // Complaint Permission View APIs
export const getComplaintPermissionDetails = async (appId) => {
  // Backend endpoint should fetch complaint permission details by appId
  const response = await axios.post(`${API_BASE}/complaint/permission/details`, { appId });
  return response.data;
};

export const saveComplaintPermission = async ({ appId, isComplaint, remarks }) => {
  // Backend endpoint to save complaint permission details
  const response = await axios.post(`${API_BASE}/complaint/permission/save`, { appId, isComplaint, remarks });
  return response.data;
};

export const updateComplaintPermission = async ({ appId, isComplaint, remarks }) => {
  // Backend endpoint to update complaint permission details
  const response = await axios.post(`${API_BASE}/complaint/permission/update`, { appId, isComplaint, remarks });
  return response.data;
};

export const sendComplaintToDO = async ({ appId }) => {
  // Backend endpoint to send complaint to D.O.
  const response = await axios.post(`${API_BASE}/complaint/permission/sendToDO`, { appId });
  return response.data;
};
